import { render } from "./TaskListArchive.vue?vue&type=template&id=473cda7e"
import script from "./TaskListArchive.vue?vue&type=script&lang=js"
export * from "./TaskListArchive.vue?vue&type=script&lang=js"

import "./TaskListArchive.vue?vue&type=style&index=0&id=473cda7e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__